export const pathRegistery = {
  employee: {
    index: '/employee',
  },
  adminSignIn: '/admin',
  signIn: '/',
  employeeSignIn: '/signin/employee',
} as const;
